window._PABLO = {

    cart: {

        add: (vid, qty = 1) => {

            if (typeof vid == 'undefined') {

                console.error('Missing Variant ID');
                return;

            }

            let cart = document.querySelector('cart-drawer');

            return fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    items: [{ id: vid, quantity: qty }],
                    sections: cart.getSectionsToRender().map(s => s.id).join(',')
                })
            }).then(response => response.json())
                .then(data => {
                    cart.classList.remove('is-empty');
                    cart.renderContents(data);
                    cart.open();
                })
                .catch(error => {
                    console.error('Add to cart error:', error);
                });
        }
    }
}

class ProductCardQuickAdd {
    constructor() {
        const body = document.querySelector('body');

        body.addEventListener('click', this.quickAddSingleVar.bind(this));
        body.addEventListener('click', this.quickAddMultiVar.bind(this));
    }

    // Add a variant to the cart
    addToCart(variantId) {
        _PABLO.cart.add(variantId, 1);
    }

    quickAddSingleVar(e) {
        const target_el = e.target.closest('.card__variants-mobile');
        if (!target_el) { return; }

        console.log('quickAddSingleVar');
        e.stopPropagation();

        const container = e.target.closest('.card__content');
        const options = container.querySelectorAll('.card__variants label');

        if (options.length == 1) {
            target_el && this.addToCart(options[0].getAttribute('data-variant'));
        } else if (options.length > 1) {
            options[0].parentElement.style.display = 'flex';
        }
    }

    quickAddMultiVar(e) {
        const target_el = e.target.closest('[data-variant]');
        if (!target_el) { return; }

        console.log('quickAddMultiVar');
        e.stopPropagation();

        this.addToCart(target_el.getAttribute('data-variant'));
    }
}

class ColInfiniteScroll {
    constructor() {

        if (!window.location.href.includes('/collections/')) { return; }
        console.log(`INIT - ${this.constructor.name}`);

        this.init();

        window._PABLO = window._PABLO || {};
        window._PABLO[this.constructor.name] = this;

        return true;
    }

    init() {
        console.log(`INIT - ${this.constructor.name}.init()`);

        document.body.removeEventListener('filter::page-updated', this.init);
        document.body.addEventListener('filter::page-updated', this.init.bind(this));

        this.downgrade_page();

        let should_init = false;
        const URL = new URLSearchParams(window.location.search);
        const activate_on = ['filter.v.option.size'];
        activate_on.forEach(param => {
            URL.get(param) && (should_init = true);
        });
        if (!should_init) { return; }

        this.upgrade_page();

    }

    bind() {
        const nextPage = this.pagination.querySelector('a[aria-label="Next page"]');
        const loadMore = document.querySelector('[data-load-more]');
        nextPage && loadMore.addEventListener('click', e => {
            e.target.disabled = true;
            e.target.innerText = 'Loading';

            const section = e.target.closest('.shopify-section').id.replace('shopify-section-', '');
            let url = nextPage.href;
            url += (url.includes('?') ? ('&') : '?') + 'sections=' + section;
            fetch(url)
                .then(r => r.json())
                .then(r => {
                    const vDOM = (new DOMParser()).parseFromString(r[section], 'text/html');

                    const ul = document.querySelector('#product-grid');
                    const loop = setInterval(() => {
                        const li = vDOM.querySelector('#product-grid li');
                        li ? ul.append(li) : clearInterval(loop);
                    }, 50);

                    document.querySelector('.pagination').replaceChildren(vDOM.querySelector('.pagination > *'));
                })
                .then(() => {
                    this.init();
                });
        });
    }

    downgrade_page() {
        const loadMore = document.querySelector('[data-load-more]');
        loadMore && loadMore.remove();

        const loadMoreStyle = document.querySelector('[data-load-more-style]');
        loadMoreStyle && loadMoreStyle.remove();
    }

    upgrade_page() {
        this.pagination = document.querySelector('.pagination-wrapper');
        const nextPage = document.querySelector('.pagination__list li:last-child a[aria-label="Next page"]');

        if (nextPage && this.pagination) {
            this.pagination.innerHTML = `
            <style data-load-more-style>
                .template-collection [data-load-more] {
                    display: block;
                    margin: 0 auto;
                    width: 200px;
                }
                .template-collection [data-load-more] ~ * {
                    display: none !important;
                }
            </style>
            <button data-load-more class="button button--secondary">
                Load more
            </button> ${this.pagination.innerHTML}`;

            this.bind();
        } else if (this.pagination) {
            //this.pagination.remove();
            this.pagination.style.display = 'none';
        }
    }


}

function handlePreviousClick() {
    const activeItem = document.querySelector(".is-active");
    if (activeItem.previousElementSibling !== null) {
        activeItem.classList.remove("is-active");
        activeItem.previousElementSibling.classList.add("is-active");
    }
}

function handleNextClick() {
    const activeItem = document.querySelector(".is-active");
    if (activeItem.nextElementSibling !== null) {
        activeItem.classList.remove("is-active");
        activeItem.nextElementSibling.classList.add("is-active");
    }
}

document.addEventListener('DOMContentLoaded', function () {

    new ColInfiniteScroll();
    new ProductCardQuickAdd();

    var tabs = document.querySelectorAll('.collaboration-tab__selector');
    var contents = document.querySelectorAll('.collaboration-tab__content');

    // Function to hide all content blocks
    function hideAllContents() {
        contents.forEach(function (content) {
            content.style.display = 'none';
        });
    }

    // Event listener for each tab
    tabs.forEach(function (tab, index) {
        tab.addEventListener('change', function () {
            // Hide all content first
            hideAllContents();

            // Show the content corresponding to the clicked tab
            var contentToShow = document.getElementById('content-' + (index + 1));
            if (contentToShow) {
                contentToShow.style.display = 'block';
            }
        });
    });

    const tables = {
        cm: document.querySelector('.cm_table'),
        inch: document.querySelector('.inch_table')
    };

    if (tables.cm && tables.inch) {
        const toggleTables = (selected) => {
            tables.cm.style.display = selected === 'cm' ? 'block' : 'none';
            tables.inch.style.display = selected === 'inch' ? 'block' : 'none';
        };

        // Initial setup: Display cm_table by default
        toggleTables('cm');

        document.querySelectorAll('input[name="size_toggle"]').forEach((input) => {
            input.addEventListener('change', () => toggleTables(input.id.includes('cm') ? 'cm' : 'inch'));
        });
    }

    // Hide Accordion when metafield is empty
    const accordions = document.querySelectorAll('.product__accordion');
    const cmTable = document.querySelector('.cm_table');
    const inchTable = document.querySelector('.inch_table');
    const modalOpener = document.querySelector('modal-opener.product-popup-modal__opener');

    // Check if both cm_table and inch_table are empty
    if (modalOpener && (!cmTable || cmTable.innerHTML.trim() === '') && (!inchTable || inchTable.innerHTML.trim() === '')) {
        modalOpener.style.display = 'none';
    }

    accordions.forEach((accordion) => {
        const content = accordion.querySelector('.accordion__content');
        if (!content || content.innerHTML.trim() === '') {
            accordion.style.display = 'none';
        }
    });


    // Remove ?variant from URL on page load
    // const url = new URL(window.location.href);
    // if (url.searchParams.has('variant')) {
    //     url.searchParams.delete('variant');
    //     window.location.href = url.toString();
    // }

    // Pawty Hat
    const checkbox = document.getElementById('actual-checkbox');
    const productInfoElement = document.querySelector('product-info');

    // Helper function to get URL parameter value
    function getQueryParam(param) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
    }

    if (checkbox) {
        const variantFromUrl = getQueryParam('variant');
        const customCheckboxLabel = document.querySelector('.custom-checkbox');
        const dataVariantId = customCheckboxLabel?.dataset.variantId;

        if (variantFromUrl) {
            // Check if variantFromUrl matches dataVariantId
            const isVariantMatching = variantFromUrl === dataVariantId;

            // Set checkbox state based on the match
            checkbox.checked = !isVariantMatching;
        }

        checkbox.addEventListener('change', () => {
            const swatches = productInfoElement.querySelectorAll('.swatch-input__input');
            const dropdown = productInfoElement.querySelector('select');

            if (swatches.length > 0) {
                swatches[0].style.display = 'none';
            }

            if (dropdown && dropdown.options.length > 0) {
                dropdown.options[0].style.display = 'none';
            }

            if (checkbox.checked) {
                const firstAvailableSwatch = Array.from(swatches).find((swatch) => swatch.style.display !== 'none');
                if (firstAvailableSwatch) {
                    firstAvailableSwatch.checked = true;
                    firstAvailableSwatch.dispatchEvent(new Event('change', { bubbles: true }));
                }

                if (dropdown) {
                    const firstAvailableOptionIndex = Array.from(dropdown.options).findIndex((option) => option.style.display !== 'none');
                    if (firstAvailableOptionIndex > 0) {
                        dropdown.selectedIndex = firstAvailableOptionIndex;
                        dropdown.dispatchEvent(new Event('change', { bubbles: true }));
                        productInfoElement.updateVariantInputs(dropdown.options[firstAvailableOptionIndex]?.dataset?.variantId);
                    }
                }

                console.log('Checkbox checked, first available swatch and option selected');
            } else {
                // Reset swatches
                swatches?.forEach((swatch, index) => swatch.checked = index === 0);
                swatches?.[0]?.dispatchEvent(new Event('change', { bubbles: true }));

                // Reset dropdown
                if (dropdown) {
                    dropdown.selectedIndex = 0;
                    dropdown.dispatchEvent(new Event('change', { bubbles: true }));
                    productInfoElement.updateVariantInputs(dropdown.options[0]?.dataset?.variantId);
                }

                productInfoElement.resetProductFormState();
            }
        });
    }
});
